import { Navigate, useLocation, useParams } from 'react-router';
import { operarPath, towerPath } from './operar/operate-types';

/**
 * A disruption ALWAYS opens in «Operar la disrupción», the new UI (PO 2026-10-27: «las
 * disrupciones siempre tienen que abrir en la nueva UI» / «la vista express tiene que ir
 * siempre a la nueva UI»). The bare `/disruptions/:urn` (once the Tower) and the Express
 * board `/express/:urn` land here and go on to Operar, whatever link brought them. The
 * one exception keeps old deep links working: a `#section` (`#transport?pnr=…`,
 * `#care?pnr=…`) points INTO the expert room's desks, so it goes to «Modo experto»
 * (`/disruptions/:urn/tower`) with its hash.
 */
export function ToOperar() {
  const { disruptionUrn = '' } = useParams();
  const { hash, search } = useLocation();
  const to = hash
    ? `${towerPath(disruptionUrn)}${search}${hash}`
    : `${operarPath(disruptionUrn)}${search}`;
  return <Navigate to={to} replace />;
}
